module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-map",
    staticStyle: {
      "position": "absolute",
      "z-index": "10",
      "width": "95%",
      "height": "90%"
    }
  }, [_c('v-btn', {
    staticClass: "go-back-btn",
    attrs: {
      "id": "hideMapBtn",
      "icon": "",
      "color": "white"
    },
    on: {
      "click": _vm.hideMap
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("arrow_forward_ios")])], 1), _vm._v(" "), _c('div', {
    ref: "mapName",
    staticClass: "google-map"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-717843ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddField/FieldMap.vue
// module id = 1737
// module chunks = 0